import billmaHttpClient from '@/services/http/billmaHttpClient'
import { paramsToString } from '@/services/http/httpClient'
import { getUserLocale } from '@/utils/userSettings'

export const billmaApiPostFile = ({ fileBlob, sinisterId, documentType }) => {
  const params = new URLSearchParams()
  const form = new FormData()

  form.append('file', fileBlob)
  form.append('externalClaimId', sinisterId)
  if (documentType) form.append('documentType', documentType)
  if (getUserLocale()) params.append('lang', getUserLocale())

  return billmaHttpClient.post(
    `/bridge/api/files/${paramsToString(params)}`,
    form
  )
}

export const billmaApiGetFile = filename => {
  const params = new URLSearchParams()
  params.set('fileName', filename)

  return billmaHttpClient.getFile(
    `/bridge/api/files/file/?${params.toString()}`
  )
}
